export default "__VITE_ASSET__37ea97fd__"